import React, { PropsWithChildren, MouseEvent } from "react";

import { StringMap } from "./lib/types";
import { clsx } from "clsx";

type Props = {
  itemType?: "div" | "span";
  className?: string;
  padding?: string;
  role?: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  onDoubleClick?: (e: MouseEvent<HTMLElement>) => void;
  forwardedRef?: any;
  style?: StringMap<any>;
  px?: string;
  py?: string;
  pl?: string;
  pr?: string;
  title?: string;
};

const Item = ({
  itemType = "div",
  className,
  padding,
  role,
  children,
  onClick,
  onDoubleClick,
  forwardedRef,
  style,
  px,
  py,
  pl,
  pr,
  title
}: PropsWithChildren<Props>) => {
  const Type = itemType;

  return (
    <Type
      className={clsx({
        item: true,
        [`${className ? className : ""}`]: className,
        [`${padding ? "p-" + padding : ""}`]: padding,
        [`${px ? "px-" + px : ""}`]: px,
        [`${py ? "py-" + py : ""}`]: py,
        [`${pl ? "pl-" + pl : ""}`]: pl,
        [`${pr ? "pr-" + pr : ""}`]: pr,
      })}
      style={style}
      ref={forwardedRef}
      role={role}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      title={title}
    >
      {children && children}
    </Type>
  );
};

export default Item;
